<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc1"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. “Use Your Best Endeavors, to Repeal Force by Force”: North America on the Eve of War</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. “Our Interest in Such an Event…Would Make This Affair Worthy or Our Most Serious Consideration”: Maryland on the Brink of War</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. “We Face the Bastions and Curtains with Stone and Shall Mount on Each of the Bastions a Six-Pounder”: Maryland Prepares a Defense</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. “The Circumstances of Our Constituents”: Maryland’s Effort Stalls</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. “The People of This Province in General Seem Dead to All Sense of Gratitude and Duty”: Maryland’s Inaction</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. “But War, Anything, Is Preferable to a Surrender of Our Rights”: The Road to Revolution</span></p>
<p class="toc1"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?27c8424c